module.exports = __webpack_public_path__ + "media/images/CMEntroncamento-d5436e27d745163794802c63baa18516.png";